import AboutUsFullPhotoBlock from "../../components/about-us-page/fullphoto-block/about-us-fullphoto-block";
import AboutUsHeroBlock from "../../components/about-us-page/hero-block/about-us-hero-block";
import AboutUsHeroBottomBlock from "../../components/about-us-page/hero-bottom/hero-bottom";
import AboutUsHeroDescriptionBlock from "../../components/about-us-page/hero-description-block/about-us-hero-description-block";
import AboutUsTimelineBlock from "../../components/about-us-page/timeline-block/about-us-timeline-block";
import "./about-us-page.sass";

const AboutUsPage = () => {
  return (
    <div className="page about-us-page">
      <AboutUsHeroBlock />

      <AboutUsHeroDescriptionBlock />

      <AboutUsFullPhotoBlock />

      <AboutUsTimelineBlock />

      <AboutUsHeroBottomBlock />
    </div>
  );
};

export default AboutUsPage;
